import { render, staticRenderFns } from "./memberBenefits.vue?vue&type=template&id=605e56a6&scoped=true"
import script from "./memberBenefits.vue?vue&type=script&lang=js"
export * from "./memberBenefits.vue?vue&type=script&lang=js"
import style0 from "./memberBenefits.vue?vue&type=style&index=0&id=605e56a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605e56a6",
  null
  
)

export default component.exports